// extracted by mini-css-extract-plugin
export default {"wrap":"ScGraphs_wrap__5X9Gh","container":"ScGraphs_container__PzueT"};